var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDelphi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 596.4,
    height: 106.8,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -63.6,
    y: 479.6,
    width: "596.4px",
    height: "106.8px"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(63.6 -479.6)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -60,
    y: 480,
    width: "94.8px",
    height: "97.2px"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -60,
    y: 555.6,
    width: "94.8px",
    height: "16.8px"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontWeight: 700,
    fontSize: 15.6,
    transform: "translate(-53.12 571.2)"
  }, "\r\n      D E L P H I\r\n      ", /*#__PURE__*/React.createElement("tspan", {
    fill: "#000000",
    fontFamily: "Tahoma,Tahoma_MSFontService,sans-serif",
    fontStyle: "oblique",
    fontSize: 35.8,
    x: 97.24,
    y: -30.4
  }, "Delphi Research Services")))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelphi);
export default __webpack_public_path__ + "static/media/Delphi.1dafa782d61467a270e7adf77e7341eb.svg";
export { ForwardRef as ReactComponent };